export default __webpack_public_path__ + "static/media/F1rstTeam.35be4f17.jpg";